import { X } from "lucide-react";

import { PlayerMoveOptions, PlayerSwapOptions } from "./TeamAdjustmentOptions";

function playerName(player) {
  return player.name || player.apelido || "Jogador";
}

export function TeamAdjustmentsModal({ match, selectedPlayerId, onClose, onMove, onSwap }) {
  const sourceTeamIndex = match.teams.findIndex((team) =>
    team.players.some((player) => player.id === selectedPlayerId),
  );
  const sourceTeam = match.teams[sourceTeamIndex];
  const selectedPlayer = sourceTeam?.players.find((player) => player.id === selectedPlayerId);

  if (!selectedPlayer) {
    return null;
  }

  return (
    <div className="modal-backdrop" data-testid="team-adjustment-modal" role="dialog" aria-modal="true">
      <section className="modal team-adjustment-sheet">
        <div className="team-adjustment-heading">
          <div>
            <span>AJUSTAR SORTEIO</span>
            <h2>{playerName(selectedPlayer)}</h2>
            <p>Escolha outro time ou selecione um jogador para trocar.</p>
          </div>
          <button className="icon-button" onClick={onClose} aria-label="Fechar ajuste" data-testid="close-team-adjustment-modal">
            <X size={18} />
          </button>
        </div>

        <PlayerMoveOptions selectedPlayer={selectedPlayer} sourceTeamIndex={sourceTeamIndex} teams={match.teams} onMove={onMove} />
        <PlayerSwapOptions selectedPlayer={selectedPlayer} sourceTeamIndex={sourceTeamIndex} teams={match.teams} onSwap={onSwap} />
      </section>
    </div>
  );
}